import map from "lodash/fp/map";
import assign from "lodash/fp/assign";
import flow from "lodash/fp/flow";
import constants from "../../core/constants";
import moment from "moment";

const formatDate = (item) => {
  item.date = moment(item.date).format(constants.dateTimeFormat);
  item.expiryDate = item.expiry_date
    ? moment(item.expiry_date).format(constants.dateTimeFormat)
    : null;

  return item;
};
const formatAmount = (item) => {
  item.amount /= constants.currencyBy;

  return item;
};

class TopupsPageTransform {
  constructor() {
    "ngInject";

    this.fields = [
      { title: "Topper", name: "topper" },
      { title: "User", name: "user" },
      { title: "Amount", name: "amountWithCurrency" },
      { title: "Comment", name: "comment" },
      { title: "Date", name: "date" },
      { title: "Expiry Date", name: "expiryDate" },
    ];

    this.filters = [
      { name: "date", title: "Select date", icon: "date_range", isDate: true },
      {
        name: "topper",
        title: "Topper",
        icon: "person_outline",
        resource: "User",
        size: 25,
      },
      {
        name: "user",
        title: "User",
        icon: "person",
        resource: "User",
        size: 25,
      },
    ];
  }

  justify(data) {
    const getSource = (item) => assign({ _id: item._id }, item._source);
    const format = (item) => {
      item.amountWithCurrency =
        item.amount / constants.currencyBy + " " + item.currency;
      return item;
    };
    return map(flow([getSource, format, formatDate, formatAmount]))(data);
  }

  justifyObj(data) {
    return flow([formatDate, formatAmount])(data);
  }
}

export default TopupsPageTransform;



// WEBPACK FOOTER //
// ./src/pages/topups/topups.transforms.js